import { css } from 'styled-components';
import { typeScale } from '../../styles/newTypography';
import { breakpointUp } from '../../styles/mediaUtils';
import { spacing } from '../../styles/newThemeVariables.styles';
import { ImageWrapper } from '../blocks/ImageBlock/ImageBlock.styles';
import { EyebrowStyles } from './Eyebrow.styles';
import { ListStyles } from './List.styles';

export const TextStyles = css`
  color: ${({ theme }) => theme.textPrimary};
  ${typeScale.mobile.body.xs};

  @media ${breakpointUp.tablet} {
    ${typeScale.tablet.body.md}
  }

  @media ${breakpointUp.desktop} {
    ${typeScale.desktop.body.md}
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.textPrimary};
    scroll-margin-top: ${({ theme }) =>
      `calc(${theme.navHeight} + ${spacing.space72})`};
    margin: ${spacing.space72} 0 ${spacing.space72};
  }

  h3,
  h4,
  h5,
  h6 {
    margin-bottom: ${spacing.space24};
  }

  h1 {
    ${typeScale.mobile.body.xxxxl}

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.xxxxl}
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.xxxxl}
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.fivexl}
    }
  }

  h2 {
    ${typeScale.mobile.body.xxxl}

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.xxxl}
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.xxxl}
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.xxxxl}
    }
  }

  h3 {
    ${typeScale.mobile.body.xxl}

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.xxl}
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.xxl}
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.xxxl}
    }
  }

  h4 {
    ${typeScale.mobile.body.xl}

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.xl}
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.xl}
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.xxl}
    }
  }

  h5 {
    ${typeScale.mobile.body.lg}

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.lg}
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.lg}
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.xl}
    }
  }

  h6 {
    ${typeScale.mobile.body.md}

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.md}
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.md}
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.lg}
    }
  }

  /* apply only to plain links and not buttons 
  or other special links wih classnames */
  a[href]:not([class]) {
    color: ${({ theme }) => theme.textLink};
    text-decoration: underline;
  }

  /* do not add top margin to very first heading */
  div :is(h1, h2, h3, h4, h5, h6):first-child {
    margin-top: 0;
  }

  /* Image components */
  ${ImageWrapper},
  figure,
  picture {
    margin: ${spacing.space72} 0;
    display: block;
  }

  picture > img {
    display: block;
    max-width: 100%;
    max-height: 80vh;
  }

  picture + p {
    ${typeScale.mobile.body.xs}
  }

  blockquote {
    margin: ${spacing.space72} 0 ${spacing.space72};

    @media ${breakpointUp.desktop} {
      margin: ${spacing.space72} 0 ${spacing.space72}
        calc(-${spacing.space24} - ${spacing.space2});
    }

    @media ${breakpointUp.lg} {
      margin: ${spacing.space72} 0 ${spacing.space72}
        calc(-${spacing.space32} - ${spacing.space2});
    }
  }

  .textSecondary {
    color: ${({ theme }) => theme.text500};
  }

  .textEyebrow {
    ${EyebrowStyles}
    color: ${({ theme }) => theme.text300};
  }

  .textHighlight {
    color: ${({ theme }) => theme.textHighlight};
  }

  /* Handle list markers */
  ${ListStyles}

  /* handle eyebrow next to heading */
  p:has(.textEyebrow) {
    margin: ${spacing.space72} 0 0;
  }

  p:has(.textEyebrow) + :is(h1, h2, h3, h4, h5, h6),
  .textEyebrow + :is(h1, h2, h3, h4, h5, h6) {
    margin: ${spacing.space16} 0 ${spacing.space24};
  }

  p:empty {
    min-height: 1em;
    margin: 0;
  }
`;
